import React, { FC } from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import PropTypes from 'prop-types';

import { deprecated } from '../../internal/propTypeValidators';
import Box from '../../layouts/Box';
import { iconSize } from '../Icon';
import Cross from '../icons/glyphs/CrossLight';
import { CloseIconProps } from './types';

export const StyledCloseIcon = styled(Box)<CloseIconProps>(
  ({ color, hoverColor }) =>
    css({
      lineHeight: 0,
      cursor: 'pointer',
      color: color,
      ':hover': {
        color: hoverColor,
        cursor: 'pointer',
      },
    })
);

const CloseIcon: FC<CloseIconProps> = ({
  onClick,
  onClose,
  closeLabel,
  size = iconSize.SMALL,
  ...rest
}) => {
  const handleClick = (event) => {
    if (onClick) onClick(event);
    if (onClose) onClose(event);
  };

  return (
    <StyledCloseIcon
      p="2x_small"
      onClick={handleClick}
      role="button"
      aria-pressed="false"
      aria-label={closeLabel}
      {...rest}
    >
      <Cross size={size} />
    </StyledCloseIcon>
  );
};

CloseIcon.propTypes = {
  onClose: deprecated(PropTypes.func),
  closeLabel: deprecated(PropTypes.string),
};

export default CloseIcon;
